/**
 * Minimal Matomo client helper.
 *
 * This app assumes Matomo is installed by the host page (script + tracker init),
 * so we only push commands to the global `_paq` queue when it exists.
 *
 * Note: The "Registration / Email Confirmed" event cannot be emitted from this
 * React app if the confirmation flow happens on a different website/backend.
 */
export function trackEvent(category: string, action: string, name?: string, value?: number): void {
  if (typeof window === 'undefined' || !window._paq) {
    return;
  }

  const cmd: unknown[] = ['trackEvent', category, action];
  if (typeof name !== 'undefined') {
    cmd.push(name);
  }
  if (typeof value !== 'undefined') {
    cmd.push(value);
  }

  window._paq.push(cmd);
  window._paq.push(['trackPageView']);
}
